import { createSlice } from "@reduxjs/toolkit";
import { fetchEnquirySummary, fetchEnquiryList } from "./thunk";

interface EnquirySummaryState {
  // Summary data
  summary: {
    total_enquiries: number;
    with_site_visit: number;
    without_site_visit: number;
  } | null;
  summaryLoading: boolean;
  summaryError: string | null;

  // List data
  enquiryList: any[];
  totalRecords: number;
  listLoading: boolean;
  listError: string | null;
}

const initialState: EnquirySummaryState = {
  summary: null,
  summaryLoading: false,
  summaryError: null,
  enquiryList: [],
  totalRecords: 0,
  listLoading: false,
  listError: null,
};

const enquirySummarySlice = createSlice({
  name: "enquirySummary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Summary thunks
      .addCase(fetchEnquirySummary.pending, (state) => {
        state.summaryLoading = true;
        state.summaryError = null;
      })
      .addCase(fetchEnquirySummary.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.summary = action.payload;
      })
      .addCase(fetchEnquirySummary.rejected, (state, action) => {
        state.summaryLoading = false;
        state.summaryError =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch enquiry summary";
        // Set default values on error
        state.summary = {
          total_enquiries: 0,
          with_site_visit: 0,
          without_site_visit: 0,
        };
      })
      // List thunks
      .addCase(fetchEnquiryList.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchEnquiryList.fulfilled, (state, action) => {
        state.listLoading = false;
        state.enquiryList = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchEnquiryList.rejected, (state, action) => {
        state.listLoading = false;
        state.listError =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch enquiry list";
        state.enquiryList = [];
        state.totalRecords = 0;
      });
  },
});

export default enquirySummarySlice.reducer;
